module.exports = __webpack_public_path__ + "img/page1-2.a7c56bf3.png";